import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

/**
 * Formats a phone number according to the specified format.
 *
 * @param raw - The raw phone number string.
 * @param format - The desired format for the phone number. Defaults to PhoneNumberFormat.E164.
 * @returns The formatted phone number string, or undefined if the phone number cannot be parsed.
 */
const formatPhoneNumber = (
  raw: string = '',
  format: PhoneNumberFormat = PhoneNumberFormat.E164,
) => {
  const hasCountryCode = `${raw}`.trim().startsWith('+');
  const rawDigits = `${raw}`.replace(/\D/g, '');
  let digits = rawDigits;

  if (rawDigits.length === 10 && !hasCountryCode) {
    // Assume North America phone
    digits = `+1${rawDigits}`;
  } else if (hasCountryCode) {
    digits = `+${rawDigits}`;
  }

  try {
    const phone = phoneUtil.parse(digits);

    return phoneUtil.format(phone, format);
  } catch (_parseError) {
    return undefined;
  }
};

export { formatPhoneNumber };
